"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TENANT_REASONS_CONFIG = exports.TENANT_REASON_IDS = exports.PAYMENT_SUPPORT = exports.DEACTIVATE_ACCOUNT = exports.CANCEL_BOOKING_REQUEST = exports.HOW_SPOTAHOME_WORKS = exports.TENANT_OTHER = exports.TENANT_CHANGE_ACCOUNT_DETAILS = exports.TENANT_ACCOUNT_ACCESS = exports.TENANT_BUG = exports.HELP_FIND_PROPERTY = exports.LISTING_DOUBTS = exports.LIST_PAYMENTS = exports.REQUEST_INVOICE = exports.TENANT_WRONG_CONTRACT = exports.DEPOSIT_DISPUTE = exports.LAST_MINUTE_CANCEL = exports.PERSONAL_CONFLICT = exports.PROPERTY_CONDITIONS = exports.LISTING_INACCURACY = exports.TENANT_BOOKING_STATUS = exports.TENANT_BC_CANCELLATION = exports.TENANT_DATES_MODIFICATIONS = exports.COMMUNICATION_ISSUES = void 0;
const COMMUNICATION_ISSUES = 'communication_issues';
exports.COMMUNICATION_ISSUES = COMMUNICATION_ISSUES;
const TENANT_DATES_MODIFICATIONS = 'tenant_dates_modification';
exports.TENANT_DATES_MODIFICATIONS = TENANT_DATES_MODIFICATIONS;
const TENANT_BC_CANCELLATION = 'tenant_bc_cancellation';
exports.TENANT_BC_CANCELLATION = TENANT_BC_CANCELLATION;
const TENANT_BOOKING_STATUS = 'tenant_booking_status';
exports.TENANT_BOOKING_STATUS = TENANT_BOOKING_STATUS;
const LISTING_INACCURACY = 'listing_inaccuracy';
exports.LISTING_INACCURACY = LISTING_INACCURACY;
const PROPERTY_CONDITIONS = 'property_conditions';
exports.PROPERTY_CONDITIONS = PROPERTY_CONDITIONS;
const PERSONAL_CONFLICT = 'personal_conflict';
exports.PERSONAL_CONFLICT = PERSONAL_CONFLICT;
const LAST_MINUTE_CANCEL = 'last_minute_cancel';
exports.LAST_MINUTE_CANCEL = LAST_MINUTE_CANCEL;
const DEPOSIT_DISPUTE = 'deposit_dispute';
exports.DEPOSIT_DISPUTE = DEPOSIT_DISPUTE;
const TENANT_WRONG_CONTRACT = 'tenant_wrong_contract';
exports.TENANT_WRONG_CONTRACT = TENANT_WRONG_CONTRACT;
const REQUEST_INVOICE = 'request_invoice';
exports.REQUEST_INVOICE = REQUEST_INVOICE;
const LIST_PAYMENTS = 'list_payments';
exports.LIST_PAYMENTS = LIST_PAYMENTS;
const LISTING_DOUBTS = 'listing_doubts';
exports.LISTING_DOUBTS = LISTING_DOUBTS;
const HELP_FIND_PROPERTY = 'help_find_property';
exports.HELP_FIND_PROPERTY = HELP_FIND_PROPERTY;
const TENANT_BUG = 'tenant_bug';
exports.TENANT_BUG = TENANT_BUG;
const TENANT_ACCOUNT_ACCESS = 'tenant_account_access';
exports.TENANT_ACCOUNT_ACCESS = TENANT_ACCOUNT_ACCESS;
const TENANT_CHANGE_ACCOUNT_DETAILS = 'tenant_change_account_details';
exports.TENANT_CHANGE_ACCOUNT_DETAILS = TENANT_CHANGE_ACCOUNT_DETAILS;
const TENANT_OTHER = 'tenant_other';
exports.TENANT_OTHER = TENANT_OTHER;
const HOW_SPOTAHOME_WORKS = 'how_spotahome_works';
exports.HOW_SPOTAHOME_WORKS = HOW_SPOTAHOME_WORKS;
const CANCEL_BOOKING_REQUEST = 'cancel_booking_request';
exports.CANCEL_BOOKING_REQUEST = CANCEL_BOOKING_REQUEST;
const DEACTIVATE_ACCOUNT = 'deactivate_account';
exports.DEACTIVATE_ACCOUNT = DEACTIVATE_ACCOUNT;
const PAYMENT_SUPPORT = 'payment_support';
exports.PAYMENT_SUPPORT = PAYMENT_SUPPORT;
const TENANT_REASON_IDS = [COMMUNICATION_ISSUES, TENANT_DATES_MODIFICATIONS, TENANT_BC_CANCELLATION, TENANT_BOOKING_STATUS, LISTING_INACCURACY, PROPERTY_CONDITIONS, PERSONAL_CONFLICT, LAST_MINUTE_CANCEL, DEPOSIT_DISPUTE, TENANT_WRONG_CONTRACT, REQUEST_INVOICE, LIST_PAYMENTS, LISTING_DOUBTS, HELP_FIND_PROPERTY, TENANT_BUG, TENANT_ACCOUNT_ACCESS, TENANT_CHANGE_ACCOUNT_DETAILS, TENANT_OTHER, HOW_SPOTAHOME_WORKS, CANCEL_BOOKING_REQUEST, DEACTIVATE_ACCOUNT, PAYMENT_SUPPORT];
exports.TENANT_REASON_IDS = TENANT_REASON_IDS;
const TENANT_REASONS_CONFIG = {
  [COMMUNICATION_ISSUES]: {
    subject: {
      prefix: "I can't contact my Landlord ",
      suffix: 'referenceCode'
    },
    tags: ['checkin_comm_issue']
  },
  [TENANT_BOOKING_STATUS]: {
    subject: {
      prefix: 'I want to know the status of my booking',
      suffix: 'referenceCode'
    },
    tags: ['br_status']
  },
  [LISTING_INACCURACY]: {
    subject: {
      prefix: 'The information shown in the listing is inaccurate',
      suffix: 'referenceCode'
    },
    tags: ['ll_policies']
  },
  [PROPERTY_CONDITIONS]: {
    subject: {
      prefix: 'There are structual issues with the property',
      suffix: 'referenceCode'
    },
    tags: ['structural_issues']
  },
  [PERSONAL_CONFLICT]: {
    subject: {
      prefix: "I am experiencing problems with my Landlord's behaviour",
      suffix: 'referenceCode'
    },
    tags: ['t_personal_conflict']
  },
  [LAST_MINUTE_CANCEL]: {
    subject: {
      prefix: 'The landlord has cancelled my booking',
      suffix: 'referenceCode'
    },
    tags: ['ll_bc_cancelled']
  },
  [DEPOSIT_DISPUTE]: {
    subject: {
      prefix: 'The landlord has not returned my security deposit',
      suffix: 'referenceCode'
    },
    tags: ['sd_not_returned']
  },
  [TENANT_WRONG_CONTRACT]: {
    subject: {
      prefix: 'I have an issue with my contract',
      suffix: 'referenceCode'
    },
    tags: ['contract_issues']
  },
  [REQUEST_INVOICE]: {
    subject: {
      prefix: 'I need an invoice',
      suffix: 'referenceCode'
    },
    tags: ['invoice_request']
  },
  [LIST_PAYMENTS]: {
    subject: {
      prefix: 'My payment failed',
      suffix: 'referenceCode'
    },
    tags: ['payment_request']
  },
  [LISTING_DOUBTS]: {
    subject: {
      prefix: 'I have questions about a property',
      suffix: 'city' // @TO-DO: Rentable Unit ID input not available yet

    },
    tags: ['features']
  },
  [HELP_FIND_PROPERTY]: {
    subject: {
      prefix: 'I need help finding a property',
      suffix: 'city'
    },
    tags: ['t_search_property']
  },
  [TENANT_BUG]: {
    subject: {
      prefix: 'I need to report a bug',
      suffix: 'tenant'
    },
    tags: ['t_panel']
  },
  [TENANT_ACCOUNT_ACCESS]: {
    subject: {
      prefix: 'I can not access my account',
      suffix: 'tenant'
    },
    tags: ['t_panel']
  },
  [TENANT_CHANGE_ACCOUNT_DETAILS]: {
    subject: {
      prefix: 'How to change my account detail',
      suffix: 'tenant'
    },
    tags: ['change_accountdetails']
  },
  [TENANT_OTHER]: {
    subject: {
      prefix: 'Other questions',
      suffix: 'tenant'
    },
    tags: ['other']
  },
  [CANCEL_BOOKING_REQUEST]: {
    subject: {
      prefix: "I want to cancel a booking request that hasn't been accepted yet",
      suffix: 'tenant'
    },
    tags: ['t_br_cancellation']
  },
  [DEACTIVATE_ACCOUNT]: {
    subject: {
      prefix: 'I want to delete my account',
      suffix: 'tenant'
    },
    tags: ['account_deactivation']
  },
  [TENANT_BC_CANCELLATION]: {
    subject: {
      prefix: 'I want to cancel my booking',
      suffix: 'tenant'
    },
    tags: []
  },
  [TENANT_DATES_MODIFICATIONS]: {
    subject: {
      prefix: "I want to modify my booking's dates",
      suffix: 'tenant'
    },
    tags: []
  },
  [PAYMENT_SUPPORT]: {
    subject: {
      prefix: 'I need support adding the payment method',
      suffix: 'tenant'
    },
    tags: []
  }
};
exports.TENANT_REASONS_CONFIG = TENANT_REASONS_CONFIG;
var _default = {
  COMMUNICATION_ISSUES,
  TENANT_DATES_MODIFICATIONS,
  TENANT_BC_CANCELLATION,
  TENANT_BOOKING_STATUS,
  LISTING_INACCURACY,
  PROPERTY_CONDITIONS,
  PERSONAL_CONFLICT,
  LAST_MINUTE_CANCEL,
  DEPOSIT_DISPUTE,
  TENANT_WRONG_CONTRACT,
  REQUEST_INVOICE,
  LIST_PAYMENTS,
  LISTING_DOUBTS,
  HELP_FIND_PROPERTY,
  TENANT_BUG,
  TENANT_ACCOUNT_ACCESS,
  TENANT_CHANGE_ACCOUNT_DETAILS,
  TENANT_OTHER,
  HOW_SPOTAHOME_WORKS,
  CANCEL_BOOKING_REQUEST,
  DEACTIVATE_ACCOUNT,
  TENANT_REASON_IDS,
  PAYMENT_SUPPORT
};
exports.default = _default;